import {
  PLAYER_ERROR_CODES_MAP,
  NOT_FOUND,
  SERVER_ERROR,
} from '../../constants'

// this has side effects as it needs to manipulate the express response object
const handleApiError = ({ res, apiError }) => {
  const { code, message } = apiError
  const type = PLAYER_ERROR_CODES_MAP[code]
  if (res) {
    /* eslint-disable no-param-reassign */
    switch (type) {
      case NOT_FOUND:
        res.statusCode = 404
        break
      case SERVER_ERROR:
        res.statusCode = 500
        break
      default:
        // do nothing
    }
    /* eslint-enable no-param-reassign */
  }
  return {
    code: type,
    message,
    httpStatus: res?.statusCode,
  }
}

export default handleApiError
